import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the unfreeze-appointments endpoint.
 * The userUuid is sent as a URL query param because the internal Next.js route
 * reads it from req.query (not req.body).
 */
export function buildUnfreezeAppointmentConfig(userUuid: string): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.UNFREEZE_APPOINTMENTS,
    queryParams: { userUuid },
  };
}
